import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`

  * {   
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
    font-family: 'Montserrat', sans-serif;
  }

  body {
    background: #fff;
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
  }

`;

export default GlobalStyle;